// extracted by mini-css-extract-plugin
export default {"DraggableCard":"bgj_a"};